/**
 * Floating Preview Widget Controller
 */


document.addEventListener('DOMContentLoaded', function () {
    const widget = document.getElementById('preview-widget');
    const widgetToggle = document.getElementById('widget-toggle');
    const widgetClose = document.getElementById('widget-close');
    const backdrop = document.getElementById('widget-backdrop');

    const widgetDayBtn = document.getElementById('widget-day-btn');
    const widgetNightBtn = document.getElementById('widget-night-btn');
    const widgetPreviewImage = document.getElementById('widget-preview-image');
    const widgetTotalPrice = document.getElementById('widget-total-price');

    const mainPreviewImage = document.getElementById('preview-image');
    const mainTotalPrice = document.getElementById('total-price');
    const wizardInlinePrice = document.getElementById('wizard-inline-price');

    if (!widget || !widgetToggle) {
        console.error('Widget elements not found');
        return;
    }

    let manuallyClosedInSession = false;

    // Toggle widget open/close
    function toggleWidget() {
        const isOpen = widget.classList.contains('open');
        if (isOpen) {
            closeWidget();
        } else {
            openWidget();
        }
    }

    // Open widget — HQ (1600²) wordt al automatisch geladen bij elke config-wijziging,
    // widget toont die zodra binnen.
    function openWidget() {
        widget.classList.add('open');
        manuallyClosedInSession = false;
        if (wizardInlinePrice) wizardInlinePrice.style.display = 'none';
    }

    // Close widget
    function closeWidget() {
        widget.classList.remove('open', 'auto-open');
        manuallyClosedInSession = true;
        if (wizardInlinePrice) wizardInlinePrice.style.display = 'block';
    }

    // Auto-open widget when scrolling to configurator section
    // Auto-close when scrolling away from configurator
    function checkConfiguratorScroll() {
        const configurator = document.getElementById('configurator');

        if (configurator) {
            const configuratorRect = configurator.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Check if configurator section is visible in viewport
            const isConfiguratorVisible = configuratorRect.top < windowHeight && configuratorRect.bottom > 0;
            // Check if we're scrolled past the top of configurator
            const isAboveConfigurator = configuratorRect.top > windowHeight / 2;

            // Desktop auto-open
            if (window.innerWidth >= 1024) {
                if (isConfiguratorVisible && !isAboveConfigurator) {
                    // Only auto-open if user hasn't manually closed it
                    if (!manuallyClosedInSession && !widget.classList.contains('open')) {
                        widget.classList.add('auto-open', 'open');
                    }
                } else {
                    // Reset manual close flag when scrolling away from configurator
                    if (!isConfiguratorVisible || isAboveConfigurator) {
                        manuallyClosedInSession = false;
                        if (widget.classList.contains('auto-open')) {
                            widget.classList.remove('auto-open', 'open');
                        }
                    }
                }
            }
            // Mobile auto-open
            else {
                if (isConfiguratorVisible && !isAboveConfigurator) {
                    // Only auto-open if user hasn't manually closed it
                    if (!manuallyClosedInSession && !widget.classList.contains('open')) {
                        widget.classList.add('auto-open', 'open');
                    }
                } else {
                    // Reset manual close flag when scrolling away
                    if (!isConfiguratorVisible || isAboveConfigurator) {
                        manuallyClosedInSession = false;
                        if (widget.classList.contains('auto-open')) {
                            widget.classList.remove('auto-open', 'open');
                        }
                    }
                }
            }
        }
    }

    // Sync preview image from main configurator to widget
    function syncPreviewImage() {
        if (mainPreviewImage && widgetPreviewImage) {
            widgetPreviewImage.src = mainPreviewImage.src;
        }
    }

    // Sync price from main configurator to widget
    function syncPrice() {
        if (mainTotalPrice && widgetTotalPrice) {
            widgetTotalPrice.textContent = mainTotalPrice.textContent;
        }
        // Also sync wizard inline price
        const wizardInlinePriceEl = document.getElementById('wizard-inline-total-price');
        if (mainTotalPrice && wizardInlinePriceEl) {
            wizardInlinePriceEl.textContent = mainTotalPrice.textContent;
        }
    }

    // Sync day/night mode
    function syncDayNight(isDay) {
        if (isDay) {
            widgetDayBtn.classList.add('active');
            widgetNightBtn.classList.remove('active');
        } else {
            widgetDayBtn.classList.remove('active');
            widgetNightBtn.classList.add('active');
        }
    }

    // Event listeners
    widgetToggle.addEventListener('click', toggleWidget);
    widgetClose.addEventListener('click', closeWidget);

    // Widget day/night buttons
    if (widgetDayBtn && widgetNightBtn) {
        widgetDayBtn.addEventListener('click', function () {
            const mainDayBtn = document.getElementById('day-btn');
            if (mainDayBtn) mainDayBtn.click();
            syncDayNight(true);
        });

        widgetNightBtn.addEventListener('click', function () {
            const mainNightBtn = document.getElementById('night-btn');
            if (mainNightBtn) mainNightBtn.click();
            syncDayNight(false);
        });

        // Container-click (padding tussen buttons) → delegate naar main-toggle
        const widgetToggleContainer = widgetDayBtn.closest('.daynight-toggle');
        if (widgetToggleContainer) {
            widgetToggleContainer.addEventListener('click', function (e) {
                if (e.target.closest('.daynight-btn')) return;
                // Klik in midden → trigger tegenovergestelde van wat nu actief is
                const nightActive = widgetNightBtn.classList.contains('active');
                const targetBtn = nightActive
                    ? document.getElementById('day-btn')
                    : document.getElementById('night-btn');
                if (targetBtn) targetBtn.click();
                syncDayNight(nightActive); // nightActive=true betekent we gaan naar dag
            });
            widgetToggleContainer.style.cursor = 'pointer';
        }
    }

    // Observe changes to main preview image
    if (mainPreviewImage) {
        const imageObserver = new MutationObserver(syncPreviewImage);
        imageObserver.observe(mainPreviewImage, {
            attributes: true,
            attributeFilter: ['src']
        });

        // Also sync on load event
        mainPreviewImage.addEventListener('load', syncPreviewImage);
    }

    // Observe changes to main loader to sync with widget loader
    const mainLoader = document.getElementById('loader');
    const widgetLoader = document.getElementById('widget-loader');

    if (mainLoader && widgetLoader) {
        const loaderObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    if (mainLoader.classList.contains('show')) {
                        widgetLoader.classList.add('show');
                    } else {
                        widgetLoader.classList.remove('show');
                    }
                }
            });
        });

        loaderObserver.observe(mainLoader, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    // Observe changes to main price
    if (mainTotalPrice) {
        const priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(mainTotalPrice, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    // Scroll listener for auto-open (desktop only)
    let scrollTimeout;
    window.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(checkConfiguratorScroll, 100);
    });

    // Initial sync
    syncPreviewImage();
    syncPrice();
    checkConfiguratorScroll();

    // Watch widget open/close state to toggle inline price
    // This catches auto-open/close from scroll events too
    if (wizardInlinePrice) {
        const widgetClassObserver = new MutationObserver(function () {
            const isOpen = widget.classList.contains('open');
            wizardInlinePrice.style.display = isOpen ? 'none' : 'block';
        });
        widgetClassObserver.observe(widget, { attributes: true, attributeFilter: ['class'] });

        // Set initial state
        wizardInlinePrice.style.display = widget.classList.contains('open') ? 'none' : 'block';
    }

    // ========================================
    // MOBILE: Collapse/Expand Toggle (chevron)
    // ========================================
    const collapseToggle = document.getElementById('widget-collapse-toggle');

    if (collapseToggle) {
        collapseToggle.addEventListener('click', function (e) {
            e.stopPropagation();

            const isCollapsed = widget.classList.contains('collapsed');

            if (isCollapsed) {
                // Expand: show full widget
                widget.classList.remove('collapsed');
                collapseToggle.querySelector('svg').style.transform = 'rotate(0deg)';
            } else {
                // Collapse: only show price bar
                widget.classList.add('collapsed');
                collapseToggle.querySelector('svg').style.transform = 'rotate(180deg)';
            }
        });

        // Reset collapse state when widget is closed/reopened
        const collapseResetObserver = new MutationObserver(function () {
            if (!widget.classList.contains('open') && widget.classList.contains('collapsed')) {
                widget.classList.remove('collapsed');
                collapseToggle.querySelector('svg').style.transform = 'rotate(0deg)';
            }
        });
        collapseResetObserver.observe(widget, { attributes: true, attributeFilter: ['class'] });
    }

    // ========================================
    // MOBILE: Header auto-hide when in configurator
    // ========================================
    if (window.innerWidth < 1024) {
        const navbar = document.querySelector('.navbar-main');

        if (navbar) {
            let lastScrollY = window.scrollY;

            window.addEventListener('scroll', function () {
                const configurator = document.getElementById('configurator');
                if (!configurator) return;

                const configuratorRect = configurator.getBoundingClientRect();
                const isInConfigurator = configuratorRect.top < 60 && configuratorRect.bottom > 0;

                if (isInConfigurator) {
                    navbar.classList.add('nav-scrolled-away');
                } else {
                    navbar.classList.remove('nav-scrolled-away');
                }

                lastScrollY = window.scrollY;
            }, { passive: true });
        }
    }

});
